import { render, staticRenderFns } from "./FilterDashboard.vue?vue&type=template&id=1196a1e1&scoped=true&"
import script from "./FilterDashboard.vue?vue&type=script&lang=js&"
export * from "./FilterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FilterDashboard.vue?vue&type=style&index=0&id=1196a1e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1196a1e1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VMenu})
